import React, { useCallback, useEffect } from 'react'

import SigninForm from '../Forms/Signin/Signin'

import './Signin.css'

const Signin = ({ showSignin, setShowSignin, order, payment }) => {    
    const closeModal = useCallback(() => {
        setShowSignin(false)
    }, [setShowSignin])
    
    useEffect(() => {
        const siginModal = document.querySelector('.signin__form')

        if(payment) document.querySelector('.signin__summary').setAttribute('class', 'list-none')

        const options = {
            threshold: 0,
            rootMargin: '0px'
        }

        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if(entry.isIntersecting) {
                    document.getElementsByTagName("BODY")[0].style.overflow = 'hidden'
                } else {
                    document.getElementsByTagName("BODY")[0].style.overflow = 'auto'
                    if(order) closeModal()
                }
            })
        }, options)

        observer.observe(siginModal)
    }, [closeModal, order, payment])

    useEffect(() => {
        if(showSignin) document.querySelector('.signin__details').setAttribute('open', 'open')
        else document.querySelector('.signin__details').removeAttribute('open')
    }, [showSignin])

    return (
        <details className="signin__details">
            <summary className="signin__summary list-none"></summary>
            <SigninForm payment={payment} order={order} closeModal={closeModal} />
        </details>
    )
}

export default Signin
